// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mention[data-v-3f917b42]{display:contents;white-space:nowrap}\n", ""]);
// Exports
module.exports = exports;
